import {UcoastEl} from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class PdpContaminantsStats extends UcoastEl {
  static htmlSelector = 'pdp-contaminants-stats'

  tabButtons: NodeListOf<HTMLElement>
  tabContents: NodeListOf<HTMLElement>

  constructor() {
    super()

    this.tabButtons = q.rl('[data-us-pdp-contaminants-stats-tab-button]', this)
    this.tabContents = q.rl('[data-us-pdp-contaminants-stats-tab-content]', this)

    this.tabButtons.forEach(button =>
      button.addEventListener('click', this.activateTab.bind(this))
    )
  }

  activateTab(event: Event) {
    event.preventDefault()

    const target = q.rt<Event, HTMLButtonElement>(event)
    const selected = q.oa(target, 'data-us-pdp-contaminants-stats-tab-button')

    this.tabButtons.forEach(button => {
      const name = q.oa(button, 'data-us-pdp-contaminants-stats-tab-button')

      button.classList.toggle('active', name === selected)
    })

    this.tabContents.forEach(content => {
      const name = q.oa(content, 'data-us-pdp-contaminants-stats-tab-content')

      content.classList.toggle('active', name === selected)
    })
  }
}
